module.exports = __webpack_public_path__ + "media/images/grey_logos/scary-mommy-046f03be504a3187bab2110003fc40c0.svg";